module.exports = __webpack_public_path__ + "static/img/15c.c1a1229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/15c.jpg
// module id = hzqT
// module chunks = 0